import { type ReactNode, useEffect, useState } from 'react'
import {
  type ApolloClient,
  ApolloProvider,
  type NormalizedCacheObject,
} from '@apollo/client'
import { apolloClient } from '@velasca/utils/apollo-client'
import { handleError } from '@velasca/utils/handle-error'

// import { type CachePersistor, LocalStorageWrapper } from 'apollo3-cache-persist'

interface ApolloProviderProps {
  children: ReactNode
}

// Example taken from: https://github.com/apollographql/apollo-cache-persist/blob/master/examples/web/src/index.tsx

export const ApolloProviderWrapper = ({ children }: ApolloProviderProps) => {
  const [client, setClient] = useState<ApolloClient<NormalizedCacheObject>>()
  // const [persistor, setPersistor] =
  //   useState<CachePersistor<NormalizedCacheObject>>()

  useEffect(() => {
    const init = () => {
      // const newPersistor = new CachePersistor({
      //   cache,
      //   storage: new LocalStorageWrapper(window.localStorage),
      //   debug: true,
      //   trigger: 'write',
      // })

      // await newPersistor.restore()
      // setPersistor(newPersistor)
      // @ts-expect-error
      setClient(apolloClient)
    }

    try {
      init()
    } catch (error) {
      handleError(error)
    }
  }, [])

  if (!client) {
    return null
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
